import { ContentPluginRootState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const getError = (state: ContentPluginRootState) => state.data.results?.error;

export default getError;
